import { includes } from 'lodash';

import loadWMSBBoxFromURL from './load-wms-bbox-from-url';

const GENERIC_DOMAIN = '/geoserver/gwc/service/tms/1.0.0/';

/**
 * Fetch the values of the bounding box for a TMS layer stored in the URL.
 *
 * @async
 * @param {string} url - The URL where the TMS is stored.
 * @returns {Promise<number[]>} The TMS layer Bounding Box.
 * @throws {Error} If something goes wrong.
 */

const loadTMSBBoxFromURL = async url => {
  try {
    let bbox = [];
    if (includes(url, GENERIC_DOMAIN)) {
      const tmsServer = url.substring(0, url.indexOf('geoserver') + 10);
      const layerName = url.substring(url.indexOf('tms') + 10, url.indexOf('@'));
      const fieldLayerArray = layerName.split(':');
      const field = fieldLayerArray[0];
      const layer = fieldLayerArray[1] || fieldLayerArray[0];
      const capabilitiesURL = `${tmsServer}${field}/wms`;
      bbox = await loadWMSBBoxFromURL({ url: capabilitiesURL, wmsLayerNames: layer });
    }
    return bbox;
  } catch (err) {
    throw new Error(err.message);
  }
};

export default loadTMSBBoxFromURL;
